package br.com.htms.inspeccaocampo.ui.screens

import br.com.htms.inspeccaocampo.ui.kit.CartaoSecao
import br.com.htms.inspeccaocampo.ui.kit.PortalOutlinedButton
import br.com.htms.inspeccaocampo.ui.kit.PortalButton
import androidx.compose.foundation.background
import androidx.compose.foundation.clickable
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.ExperimentalLayoutApi
import androidx.compose.foundation.layout.FlowRow
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.size
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.material3.Card
import androidx.compose.material3.CardDefaults
import androidx.compose.material3.Checkbox
import androidx.compose.material3.CircularProgressIndicator
import androidx.compose.material3.FilterChip
import androidx.compose.material3.HorizontalDivider
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Text
import androidx.compose.material3.TextButton
import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.collectAsState
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.unit.dp
import br.com.htms.inspeccaocampo.data.epi.EpiCa
import br.com.htms.inspeccaocampo.data.epi.EpiCatalog
import br.com.htms.inspeccaocampo.data.epi.EpiMatrizFuncao
import br.com.htms.inspeccaocampo.data.epi.EpiRelacaoItem
import br.com.htms.inspeccaocampo.data.epi.EpiUso
import br.com.htms.inspeccaocampo.data.epi.FichaEpiDados
import br.com.htms.inspeccaocampo.data.epi.FichaEpiLinha
import br.com.htms.inspeccaocampo.data.funcionarios.Cpf
import br.com.htms.inspeccaocampo.data.funcionarios.Funcionario
import br.com.htms.inspeccaocampo.data.funcionarios.FuncionariosApi
import br.com.htms.inspeccaocampo.data.os.PgrCargoOpcao
import br.com.htms.inspeccaocampo.data.os.PgrCatalog
import br.com.htms.inspeccaocampo.export.FichaEpiPdfBuilder
import br.com.htms.inspeccaocampo.form.AppController
import br.com.htms.inspeccaocampo.form.AppTab
import br.com.htms.inspeccaocampo.platform.currentTimeMillis
import br.com.htms.inspeccaocampo.platform.formatDateBr
import br.com.htms.inspeccaocampo.shared.ui.components.AppDateTextField
import br.com.htms.inspeccaocampo.shared.ui.components.AppOutlinedTextField
import br.com.htms.inspeccaocampo.shared.ui.components.DateFieldKind
import br.com.htms.inspeccaocampo.shared.ui.components.DateInputMask
import br.com.htms.inspeccaocampo.shared.ui.components.FormFieldDefaults

private data class LinhaEpi(
    val key: Int,
    val incluir: Boolean,
    val descricao: String,
    val quantidade: String,
    val ca: String,
    val relacao: EpiRelacaoItem?,
    val opcao: Int,
    val uso: EpiUso?,
    val origem: String
)

private var proximaChaveEpi = 0

private fun novaLinhaDaRelacao(
    item: EpiRelacaoItem,
    descricao: String,
    quantidade: String,
    dataEntrega: String,
    uso: EpiUso?,
    origem: String
): LinhaEpi {
    val op = EpiCatalog.melhorOpcao(item, dataEntrega)
    return LinhaEpi(
        key = ++proximaChaveEpi,
        incluir = true,
        descricao = descricao,
        quantidade = quantidade,
        ca = item.opcoes.getOrNull(op)?.ca.orEmpty(),
        relacao = item,
        opcao = op,
        uso = uso,
        origem = origem
    )
}

private fun linhaLivre(descricao: String, origem: String) = LinhaEpi(
    key = ++proximaChaveEpi,
    incluir = true,
    descricao = descricao,
    quantidade = "1 uni",
    ca = "",
    relacao = null,
    opcao = 0,
    uso = null,
    origem = origem
)

private fun linhasDaMatriz(funcao: EpiMatrizFuncao, dataEntrega: String): List<LinhaEpi> =
    funcao.usos.flatMap { (col, uso) ->
        val principais = buildList {
            val item = EpiCatalog.relacaoDe(col)
            if (item != null) {
                add(novaLinhaDaRelacao(item, col.descricaoFicha, col.quantidade, dataEntrega, uso, "Matriz"))
            } else {
                add(linhaLivre(col.descricaoFicha, "Matriz").copy(quantidade = col.quantidade, uso = uso))
            }
            // Uniforme RF: camisa + calça retardante
            if (col.relacaoChave == "camisa retardante") {
                val calca = EpiCatalog.relacao.firstOrNull { "calca retardante" in PgrCatalog.normalizar(it.item) }
                if (calca != null) {
                    add(novaLinhaDaRelacao(calca, "Calça retardante de chamas", "1 uni", dataEntrega, uso, "Matriz"))
                }
            }
        }
        principais
    }

/** Seleção de funcionário cadastrado (busca por nome/CPF) com cartão do selecionado e "Trocar". */
@Composable
internal fun FuncionarioSeletor(
    funcionarios: List<Funcionario>,
    selecionado: Funcionario?,
    onSelecionar: (Funcionario) -> Unit,
    onTrocar: () -> Unit
) {
    var busca by remember { mutableStateOf("") }
    if (selecionado == null) {
        AppOutlinedTextField(
            value = busca,
            onValueChange = { busca = it },
            label = { Text("Funcionário cadastrado (buscar por nome, CPF ou matrícula)") },
            singleLine = true,
            modifier = Modifier.fillMaxWidth(),
            colors = FormFieldDefaults.textFieldColors()
        )
        if (busca.isNotBlank()) {
            val achados = filtrarFuncionarios(funcionarios, busca).take(8)
            Card(
                modifier = Modifier.fillMaxWidth(),
                colors = CardDefaults.cardColors(containerColor = MaterialTheme.colorScheme.surfaceVariant)
            ) {
                if (achados.isEmpty()) {
                    Text(
                        "Nenhum cadastro encontrado — preencha os dados abaixo; o funcionário será cadastrado ao gerar o documento.",
                        modifier = Modifier.padding(12.dp),
                        style = MaterialTheme.typography.bodySmall
                    )
                }
                achados.forEachIndexed { i, f ->
                    if (i > 0) HorizontalDivider()
                    Column(
                        modifier = Modifier
                            .fillMaxWidth()
                            .clickable {
                                busca = ""
                                onSelecionar(f)
                            }
                            .padding(horizontal = 12.dp, vertical = 8.dp)
                    ) {
                        Text(f.nomeComVinculo, fontWeight = FontWeight.SemiBold)
                        Text(
                            "CPF ${f.cpfFormatado}" + (if (f.cargoNome.isNotBlank()) " • ${f.cargoNome}" else ""),
                            style = MaterialTheme.typography.bodySmall
                        )
                    }
                }
            }
        }
    } else {
        Card(
            modifier = Modifier.fillMaxWidth(),
            colors = CardDefaults.cardColors(containerColor = MaterialTheme.colorScheme.secondaryContainer)
        ) {
            Row(Modifier.padding(12.dp), verticalAlignment = Alignment.CenterVertically) {
                Column(Modifier.weight(1f)) {
                    Text("Funcionário cadastrado", style = MaterialTheme.typography.labelMedium)
                    Text(selecionado.nomeComVinculo, fontWeight = FontWeight.Bold)
                    Text(
                        "CPF ${selecionado.cpfFormatado} • ${selecionado.totalDocumentos} documento(s)",
                        style = MaterialTheme.typography.bodySmall
                    )
                }
                TextButton(onClick = onTrocar) { Text("Trocar") }
            }
        }
    }
}

@OptIn(ExperimentalLayoutApi::class)
@Composable
fun SharedFichaEpiScreen(controller: AppController, embutido: Boolean = false) {
    val gerando by controller.gerandoFichaEpi.collectAsState()
    val versaoDocs by controller.documentosVersao.collectAsState()
    val funcionarioInicial by controller.fichaEpiFuncionarioInicial.collectAsState()
    val relacaoEpi by controller.epiRelacao.collectAsState()
    val hoje = remember { formatDateBr(currentTimeMillis()).substringBefore(' ') }
    var mostrarCatalogo by remember { mutableStateOf(false) }
    var draftCatalogo by remember { mutableStateOf<List<EpiRelacaoItem>>(emptyList()) }
    var buscaCatalogo by remember { mutableStateOf("") }
    var novoItemNome by remember { mutableStateOf("") }
    var novoItemCa by remember { mutableStateOf("") }

    var funcionarios by remember { mutableStateOf<List<Funcionario>>(emptyList()) }
    var funcionario by remember { mutableStateOf<Funcionario?>(null) }
    var nome by remember { mutableStateOf("") }
    var cpf by remember { mutableStateOf("") }
    var matricula by remember { mutableStateOf("") }
    var admissao by remember { mutableStateOf("") }
    var cargo by remember { mutableStateOf<PgrCargoOpcao?>(null) }
    var empresa by remember { mutableStateOf("HTMS ENERGIA LTDA") }
    var dataEntrega by remember { mutableStateOf(hoje) }
    var linhas by remember { mutableStateOf<List<LinhaEpi>>(emptyList()) }
    var buscaRelacao by remember { mutableStateOf("") }
    var tentouGerar by remember { mutableStateOf(false) }

    val funcaoMatriz = remember(cargo) { cargo?.let { EpiCatalog.encontrarFuncao(it.setor.nome, it.cargo.nome) } }
    val sugestoesPgr = remember(cargo) { cargo?.let { PgrCatalog.episSugeridos(it) }.orEmpty() }

    fun selecionarCargo(op: PgrCargoOpcao?) {
        cargo = op
        val f = op?.let { EpiCatalog.encontrarFuncao(it.setor.nome, it.cargo.nome) }
        linhas = f?.let { linhasDaMatriz(it, dataEntrega) }.orEmpty()
    }

    fun aplicarFuncionario(f: Funcionario) {
        funcionario = f
        nome = f.nome
        cpf = f.cpf
        matricula = f.matricula
        admissao = f.admissao
        selecionarCargo(cargoDoFuncionario(f))
    }

    fun atualizar(key: Int, bloco: (LinhaEpi) -> LinhaEpi) {
        linhas = linhas.map { if (it.key == key) bloco(it) else it }
    }

    LaunchedEffect(versaoDocs) {
        FuncionariosApi.listar().onSuccess { lista ->
            funcionarios = lista
            val atual = funcionario
            if (atual != null) funcionario = lista.firstOrNull { it.id == atual.id } ?: atual
            if (atual == null && Cpf.valido(cpf)) {
                lista.firstOrNull { it.cpf == Cpf.digitos(cpf) }?.let { funcionario = it }
            }
        }
    }
    LaunchedEffect(funcionarioInicial) {
        funcionarioInicial?.let {
            aplicarFuncionario(it)
            controller.consumirFichaEpiFuncionarioInicial()
        }
    }

    val incluidas = linhas.filter { it.incluir && it.descricao.isNotBlank() }
    val nomeOk = nome.isNotBlank()
    val cpfOk = cpf.isBlank() || Cpf.valido(cpf)
    val admissaoOk = admissao.isBlank() || DateInputMask.isCompleteValid(admissao, DateFieldKind.DATE)
    val dataOk = DateInputMask.isCompleteValid(dataEntrega, DateFieldKind.DATE)
    val qtdOk = incluidas.isNotEmpty() && incluidas.size <= FichaEpiPdfBuilder.MAX_ITENS
    val podeGerar = nomeOk && cpfOk && admissaoOk && dataOk && cargo != null && qtdOk && !gerando

    DocumentosModulo(controller, AppTab.FICHA_EPI, "Ficha de EPI", embutido = embutido) {
        CartaoSecao(
            titulo = "Catálogo de C.A",
            subtitulo = "Atualize o código C.A ou cadastre EPI que ainda não existe. Vale para as próximas fichas neste aparelho/navegador."
        ) {
            PortalOutlinedButton(
                onClick = {
                    if (!mostrarCatalogo) {
                        draftCatalogo = relacaoEpi
                        buscaCatalogo = ""
                    }
                    mostrarCatalogo = !mostrarCatalogo
                },
                modifier = Modifier.fillMaxWidth()
            ) {
                Text(if (mostrarCatalogo) "Fechar catálogo de C.A" else "Abrir / editar catálogo de C.A")
            }
            if (mostrarCatalogo) {
                Column(verticalArrangement = Arrangement.spacedBy(10.dp), modifier = Modifier.padding(top = 8.dp)) {
                    AppOutlinedTextField(
                        value = buscaCatalogo,
                        onValueChange = { buscaCatalogo = it },
                        label = { Text("Buscar no catálogo (nome ou C.A)") },
                        singleLine = true,
                        modifier = Modifier.fillMaxWidth(),
                        colors = FormFieldDefaults.textFieldColors()
                    )
                    val termos = PgrCatalog.normalizar(buscaCatalogo).split(' ').filter { it.isNotBlank() }
                    val visiveis = draftCatalogo.mapIndexed { idx, item -> idx to item }.filter { (_, item) ->
                        if (termos.isEmpty()) true
                        else {
                            val alvo = PgrCatalog.normalizar(
                                item.item + " " + item.opcoes.joinToString(" ") { "${it.marca} ${it.ca}" }
                            )
                            termos.all { it in alvo }
                        }
                    }.take(20)
                    visiveis.forEach { (idx, item) ->
                        val op = item.opcoes.firstOrNull() ?: EpiCa("", "", "")
                        Card(
                            modifier = Modifier.fillMaxWidth(),
                            colors = CardDefaults.cardColors(containerColor = MaterialTheme.colorScheme.surfaceVariant)
                        ) {
                            Column(Modifier.padding(10.dp), verticalArrangement = Arrangement.spacedBy(6.dp)) {
                                Text(item.item, fontWeight = FontWeight.SemiBold, style = MaterialTheme.typography.bodyMedium)
                                Row(horizontalArrangement = Arrangement.spacedBy(8.dp), modifier = Modifier.fillMaxWidth()) {
                                    AppOutlinedTextField(
                                        value = op.ca,
                                        onValueChange = { v ->
                                            draftCatalogo = draftCatalogo.toMutableList().also { lista ->
                                                val ops = item.opcoes.toMutableList()
                                                if (ops.isEmpty()) ops += EpiCa("", v.trim(), "")
                                                else ops[0] = ops[0].copy(ca = v.trim())
                                                lista[idx] = item.copy(opcoes = ops)
                                            }
                                        },
                                        label = { Text("C.A") },
                                        singleLine = true,
                                        modifier = Modifier.weight(1f),
                                        colors = FormFieldDefaults.textFieldColors()
                                    )
                                    AppOutlinedTextField(
                                        value = op.marca,
                                        onValueChange = { v ->
                                            draftCatalogo = draftCatalogo.toMutableList().also { lista ->
                                                val ops = item.opcoes.toMutableList()
                                                if (ops.isEmpty()) ops += EpiCa(v.trim(), "", "")
                                                else ops[0] = ops[0].copy(marca = v.trim())
                                                lista[idx] = item.copy(opcoes = ops)
                                            }
                                        },
                                        label = { Text("Marca") },
                                        singleLine = true,
                                        modifier = Modifier.weight(1f),
                                        colors = FormFieldDefaults.textFieldColors()
                                    )
                                }
                                AppOutlinedTextField(
                                    value = op.validade,
                                    onValueChange = { v ->
                                        draftCatalogo = draftCatalogo.toMutableList().also { lista ->
                                            val ops = item.opcoes.toMutableList()
                                            if (ops.isEmpty()) ops += EpiCa("", "", v.trim())
                                            else ops[0] = ops[0].copy(validade = v.trim())
                                            lista[idx] = item.copy(opcoes = ops)
                                        }
                                    },
                                    label = { Text("Validade do C.A (dd/mm/aaaa)") },
                                    singleLine = true,
                                    modifier = Modifier.fillMaxWidth(),
                                    colors = FormFieldDefaults.textFieldColors()
                                )
                            }
                        }
                    }
                    if (visiveis.isEmpty()) {
                        Text("Nenhum item encontrado.", style = MaterialTheme.typography.bodySmall)
                    }
                    HorizontalDivider()
                    Text("Cadastrar EPI novo", fontWeight = FontWeight.SemiBold)
                    AppOutlinedTextField(
                        value = novoItemNome,
                        onValueChange = { novoItemNome = it },
                        label = { Text("Descrição do EPI") },
                        singleLine = true,
                        modifier = Modifier.fillMaxWidth(),
                        colors = FormFieldDefaults.textFieldColors()
                    )
                    AppOutlinedTextField(
                        value = novoItemCa,
                        onValueChange = { novoItemCa = it },
                        label = { Text("C.A (use N/A se não tiver)") },
                        singleLine = true,
                        modifier = Modifier.fillMaxWidth(),
                        colors = FormFieldDefaults.textFieldColors()
                    )
                    PortalOutlinedButton(
                        onClick = {
                            val nome = novoItemNome.trim()
                            if (nome.isBlank()) return@PortalOutlinedButton
                            draftCatalogo = draftCatalogo + EpiRelacaoItem(
                                nome.uppercase(),
                                listOf(EpiCa("", novoItemCa.trim().ifBlank { "N/A" }, ""))
                            )
                            novoItemNome = ""
                            novoItemCa = ""
                        },
                        modifier = Modifier.fillMaxWidth()
                    ) { Text("+ Adicionar ao catálogo") }
                    Row(horizontalArrangement = Arrangement.spacedBy(8.dp), modifier = Modifier.fillMaxWidth()) {
                        PortalOutlinedButton(
                            onClick = {
                                draftCatalogo = EpiCatalog.seedRelacao()
                                controller.restaurarRelacaoEpiPadrao()
                            },
                            modifier = Modifier.weight(1f)
                        ) { Text("Restaurar padrão") }
                        PortalButton(
                            onClick = {
                                controller.salvarRelacaoEpi(draftCatalogo)
                                mostrarCatalogo = false
                            },
                            modifier = Modifier.weight(1f)
                        ) { Text("Salvar C.A") }
                    }
                }
            }
        }

        CartaoSecao(
            titulo = "Preenchimento da ficha",
            subtitulo = "Base: ${PgrCatalog.fonte} (cargo/setor) + ${EpiCatalog.fonte} (EPIs por função e CA). Sai em uma página."
        ) {
        Column(verticalArrangement = Arrangement.spacedBy(12.dp)) {
        FuncionarioSeletor(
            funcionarios = funcionarios,
            selecionado = funcionario,
            onSelecionar = { aplicarFuncionario(it) },
            onTrocar = {
                funcionario = null
                nome = ""
                cpf = ""
                matricula = ""
                admissao = ""
                selecionarCargo(null)
            }
        )

        AppOutlinedTextField(
            value = nome,
            onValueChange = { nome = it },
            label = { Text("Nome do funcionário") },
            singleLine = true,
            isError = tentouGerar && !nomeOk,
            modifier = Modifier.fillMaxWidth(),
            colors = FormFieldDefaults.textFieldColors()
        )
        CpfTextField(value = cpf, onValueChange = { cpf = it }, isError = !cpfOk && (Cpf.digitos(cpf).length == 11 || tentouGerar))
        Row(horizontalArrangement = Arrangement.spacedBy(8.dp), modifier = Modifier.fillMaxWidth()) {
            AppOutlinedTextField(
                value = matricula,
                onValueChange = { matricula = it.take(40) },
                label = { Text("Matrícula") },
                singleLine = true,
                modifier = Modifier.weight(1f),
                colors = FormFieldDefaults.textFieldColors()
            )
            AppOutlinedTextField(
                value = empresa,
                onValueChange = { empresa = it },
                label = { Text("Empresa") },
                singleLine = true,
                modifier = Modifier.weight(1f),
                colors = FormFieldDefaults.textFieldColors()
            )
        }
        AppDateTextField(
            value = admissao,
            onValueChange = { admissao = it },
            label = "Data de admissão",
            isError = !admissaoOk
        )

        CargoPgrPicker(
            selecionado = cargo,
            onSelecionar = { selecionarCargo(it) },
            isError = tentouGerar && cargo == null
        )

        AppDateTextField(
            value = dataEntrega,
            onValueChange = { nova ->
                dataEntrega = nova
                if (DateInputMask.isCompleteValid(nova, DateFieldKind.DATE)) {
                    // Troca automática de marca só nas linhas cujo CA não foi editado à mão.
                    linhas = linhas.map { l ->
                        val item = l.relacao ?: return@map l
                        if (l.ca != item.opcoes.getOrNull(l.opcao)?.ca.orEmpty()) return@map l
                        val op = EpiCatalog.melhorOpcao(item, nova)
                        l.copy(opcao = op, ca = item.opcoes.getOrNull(op)?.ca.orEmpty())
                    }
                }
            },
            label = "Data de entrega (vale para todos os EPIs)",
            isError = !dataOk
        )

        if (cargo != null) {
            Row(
                modifier = Modifier
                    .fillMaxWidth()
                    .background(MaterialTheme.colorScheme.surfaceVariant, RoundedCornerShape(8.dp))
                    .padding(10.dp)
            ) {
                Text(
                    when {
                        funcaoMatriz == null ->
                            "Esta função não foi encontrada na Matriz de EPI. Adicione os EPIs pela relação ou como item manual."
                        funcaoMatriz.usos.isEmpty() ->
                            "Pela Matriz de EPI, ${funcaoMatriz.funcao} (${funcaoMatriz.setor}) não tem EPI previsto " +
                                "(todas as colunas com \"-\"). Se houver entrega, adicione pela relação ou como item manual."
                        else ->
                            "Matriz: ${funcaoMatriz.setor} / ${funcaoMatriz.funcao}. " +
                                "X = uso básico • XX = ao entrar em área de risco • XXX = quando necessário para a atividade."
                    },
                    style = MaterialTheme.typography.bodySmall,
                    color = if (funcaoMatriz != null && funcaoMatriz.usos.isNotEmpty()) {
                        MaterialTheme.colorScheme.onSurfaceVariant
                    } else {
                        Color(0xFF8A5300)
                    }
                )
            }
        }

        if (linhas.isNotEmpty()) {
            Text(
                "EPIs da ficha (${incluidas.size}/${FichaEpiPdfBuilder.MAX_ITENS})",
                fontWeight = FontWeight.SemiBold
            )
        }
        linhas.forEach { l ->
            Card(
                modifier = Modifier.fillMaxWidth(),
                colors = CardDefaults.cardColors(
                    containerColor = if (l.incluir) MaterialTheme.colorScheme.surface else MaterialTheme.colorScheme.surfaceVariant
                )
            ) {
                Column(Modifier.padding(8.dp), verticalArrangement = Arrangement.spacedBy(6.dp)) {
                    Row(verticalAlignment = Alignment.CenterVertically) {
                        Checkbox(checked = l.incluir, onCheckedChange = { v -> atualizar(l.key) { it.copy(incluir = v) } })
                        Column(Modifier.weight(1f)) {
                            Text(l.descricao.ifBlank { "(sem descrição)" }, fontWeight = FontWeight.SemiBold)
                            Text(
                                buildString {
                                    append(l.origem)
                                    l.uso?.let { append(" • ${it.sigla} — ${it.rotulo}") }
                                },
                                style = MaterialTheme.typography.bodySmall,
                                color = MaterialTheme.colorScheme.onSurfaceVariant
                            )
                        }
                        if (l.origem != "Matriz") {
                            TextButton(onClick = { linhas = linhas.filterNot { it.key == l.key } }) { Text("Remover") }
                        }
                    }
                    if (l.incluir) {
                        Row(horizontalArrangement = Arrangement.spacedBy(8.dp), modifier = Modifier.fillMaxWidth()) {
                            AppOutlinedTextField(
                                value = l.quantidade,
                                onValueChange = { v -> atualizar(l.key) { it.copy(quantidade = v) } },
                                label = { Text("Quant.") },
                                singleLine = true,
                                modifier = Modifier.weight(1f),
                                colors = FormFieldDefaults.textFieldColors()
                            )
                            AppOutlinedTextField(
                                value = l.ca,
                                onValueChange = { v -> atualizar(l.key) { it.copy(ca = v.trim()) } },
                                label = { Text("C.A") },
                                singleLine = true,
                                modifier = Modifier.weight(1f),
                                colors = FormFieldDefaults.textFieldColors()
                            )
                        }
                        AppOutlinedTextField(
                            value = l.descricao,
                            onValueChange = { v -> atualizar(l.key) { it.copy(descricao = v) } },
                            label = { Text("Descrição na ficha") },
                            singleLine = true,
                            modifier = Modifier.fillMaxWidth(),
                            colors = FormFieldDefaults.textFieldColors()
                        )
                        val item = l.relacao
                        if (item != null && item.opcoes.size > 1) {
                            FlowRow(horizontalArrangement = Arrangement.spacedBy(6.dp)) {
                                item.opcoes.forEachIndexed { i, op ->
                                    val vencido = EpiCatalog.caValidoEm(op, dataEntrega) == false
                                    FilterChip(
                                        selected = l.ca == op.ca && l.opcao == i,
                                        onClick = { atualizar(l.key) { it.copy(opcao = i, ca = op.ca) } },
                                        label = {
                                            Text(
                                                "${op.marca} • CA ${op.ca.ifBlank { "-" }}" +
                                                    (if (vencido) " (vencido)" else ""),
                                                style = MaterialTheme.typography.bodySmall
                                            )
                                        }
                                    )
                                }
                            }
                        }
                        val escolhida = item?.opcoes?.getOrNull(l.opcao)?.takeIf { it.ca == l.ca }
                        when {
                            l.ca.isBlank() -> Text(
                                "Sem CA — sai como N/A. Informe o CA se o item exigir.",
                                style = MaterialTheme.typography.bodySmall,
                                color = Color(0xFF8A5300)
                            )
                            escolhida != null && EpiCatalog.caValidoEm(escolhida, dataEntrega) == false -> Text(
                                "CA ${escolhida.ca} vencido em ${escolhida.validade} (data de entrega $dataEntrega).",
                                style = MaterialTheme.typography.bodySmall,
                                color = MaterialTheme.colorScheme.error
                            )
                            escolhida != null && escolhida.validade.isNotBlank() -> Text(
                                "${escolhida.marca} • CA válido até ${escolhida.validade}",
                                style = MaterialTheme.typography.bodySmall,
                                color = MaterialTheme.colorScheme.onSurfaceVariant
                            )
                        }
                    }
                }
            }
        }

        if (cargo != null) {
            if (sugestoesPgr.isNotEmpty()) {
                Text("Sugeridos pelo PGR (toque para adicionar)", fontWeight = FontWeight.SemiBold)
                FlowRow(horizontalArrangement = Arrangement.spacedBy(6.dp)) {
                    sugestoesPgr.forEach { s ->
                        val jaTem = linhas.any { PgrCatalog.normalizar(it.descricao) == PgrCatalog.normalizar(s) }
                        FilterChip(
                            selected = jaTem,
                            onClick = { if (!jaTem) linhas = linhas + linhaLivre(s, "PGR") },
                            label = { Text(s, style = MaterialTheme.typography.bodySmall) }
                        )
                    }
                }
            }

            AppOutlinedTextField(
                value = buscaRelacao,
                onValueChange = { buscaRelacao = it },
                label = { Text("Adicionar da relação de EPI (buscar)") },
                singleLine = true,
                modifier = Modifier.fillMaxWidth(),
                colors = FormFieldDefaults.textFieldColors()
            )
            if (buscaRelacao.isNotBlank()) {
                val termos = PgrCatalog.normalizar(buscaRelacao).split(' ').filter { it.isNotBlank() }
                val achados = EpiCatalog.relacao.filter { r ->
                    val alvo = PgrCatalog.normalizar(r.item + " " + r.opcoes.joinToString(" ") { "${it.marca} ${it.ca}" })
                    termos.all { it in alvo }
                }.take(10)
                Card(
                    modifier = Modifier.fillMaxWidth(),
                    colors = CardDefaults.cardColors(containerColor = MaterialTheme.colorScheme.surfaceVariant)
                ) {
                    if (achados.isEmpty()) Text("Nenhum item na relação.", modifier = Modifier.padding(12.dp))
                    achados.forEachIndexed { i, r ->
                        if (i > 0) HorizontalDivider()
                        Column(
                            modifier = Modifier
                                .fillMaxWidth()
                                .clickable {
                                    linhas = linhas + novaLinhaDaRelacao(r, r.item, "1 uni", dataEntrega, null, "Relação")
                                    buscaRelacao = ""
                                }
                                .padding(horizontal = 12.dp, vertical = 8.dp)
                        ) {
                            Text(r.item, fontWeight = FontWeight.SemiBold, style = MaterialTheme.typography.bodyMedium)
                            Text(
                                r.opcoes.joinToString("  |  ") { "${it.marca} CA ${it.ca.ifBlank { "-" }}" },
                                style = MaterialTheme.typography.bodySmall
                            )
                        }
                    }
                }
            }
            PortalOutlinedButton(
                onClick = { linhas = linhas + linhaLivre("", "Manual") },
                modifier = Modifier.fillMaxWidth()
            ) { Text("+ Item manual") }
        }

        if (incluidas.size > FichaEpiPdfBuilder.MAX_ITENS) {
            Text(
                "Máximo de ${FichaEpiPdfBuilder.MAX_ITENS} EPIs para a ficha caber em uma página.",
                color = MaterialTheme.colorScheme.error,
                style = MaterialTheme.typography.bodySmall
            )
        }
        if (tentouGerar && !podeGerar && !gerando) {
            val faltando = buildList {
                if (!nomeOk) add("nome")
                if (!cpfOk) add("CPF válido (ou deixe em branco)")
                if (!admissaoOk) add("data de admissão válida")
                if (cargo == null) add("cargo do PGR")
                if (!dataOk) add("data de entrega")
                if (incluidas.isEmpty()) add("pelo menos um EPI marcado")
            }
            if (faltando.isNotEmpty()) {
                Text(
                    "Falta: " + faltando.joinToString(", ") + ".",
                    color = MaterialTheme.colorScheme.error,
                    style = MaterialTheme.typography.bodySmall
                )
            }
        }

        PortalButton(
            onClick = {
                tentouGerar = true
                val op = cargo ?: return@PortalButton
                if (!podeGerar) return@PortalButton
                controller.gerarFichaEpiPdf(
                    FichaEpiDados(
                        nome = nome.trim(),
                        cpf = cpf,
                        matricula = matricula.trim(),
                        funcao = op.cargo.nome,
                        setor = op.setor.nome,
                        admissao = admissao,
                        empresa = empresa.trim(),
                        dataEntrega = dataEntrega,
                        linhas = incluidas.map { FichaEpiLinha(it.quantidade.trim(), it.ca.trim(), it.descricao.trim()) }
                    ),
                    cargoId = op.id,
                    setorGhe = op.setorGhe
                )
            },
            enabled = !gerando,
            modifier = Modifier.fillMaxWidth()
        ) {
            if (gerando) {
                CircularProgressIndicator(modifier = Modifier.size(18.dp), strokeWidth = 2.dp)
                Text("  Gerando PDF...")
            } else {
                Text(if (Cpf.valido(cpf)) "Gerar Ficha de EPI e salvar no cadastro" else "Gerar Ficha de EPI (PDF)")
            }
        }

        }
        }

        funcionario?.let { FuncionarioDocumentosPanel(controller, it) }
    }
}
